import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <p className="home-about-body">
          <h1 >About <strong>Myself</strong> </h1>
              Hello There!
              <br />
              <br />I am a pre-final year B.Tech student at Dharmsinh Desai University, Gujarat.
             
              <br /> Passionate about tech, team worker and always ready to learn new technologies. Experience in App development using Flutter and Swift technologies. Skilled in Python, C++, Dart with basic knowledge in Machine Learning.
             </p>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
